// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';

import { RolesService } from '@app/core';
import {
  ScopesActionTypes,
  LoadingScopeCategoriesAction,
  CompleteLoadScopeCategoriesAction,
  FailLoadScopeCategoriesAction,
  LoadingScopeConstraintsAction,
  CompleteLoadScopeConstraintsAction,
  FailLoadScopeConstraintsAction
} from './role-scope.actions';

@Injectable()
export class ScopesEffects {
  @Effect()
  requestOnLoadScopeCategories$ = this.actions$.pipe(
    ofType<LoadingScopeCategoriesAction>(ScopesActionTypes.SCOPE_CATEGORIES_LOADING),
    flatMap(action => this.requestScopeCategories())
  );

  @Effect()
  requestOnLoadScopeConstraints$ = this.actions$.pipe(
    ofType<LoadingScopeConstraintsAction>(ScopesActionTypes.SCOPE_CONSTRAINTS_LOADING),
    flatMap(action => this.requestScopeConstraints(action.payload))
  );

  constructor(private actions$: Actions, private rolesService: RolesService) {}

  private requestScopeCategories(): Observable<CompleteLoadScopeCategoriesAction | FailLoadScopeCategoriesAction> {
    return this.rolesService
      .getScopeCategories()
      .pipe(
        map(scopes => new CompleteLoadScopeCategoriesAction(scopes)),
        catchError(_ => of(new FailLoadScopeCategoriesAction()))
      );
  }

  private requestScopeConstraints(
    categoryId: string
  ): Observable<CompleteLoadScopeConstraintsAction | FailLoadScopeConstraintsAction> {
    return this.rolesService
      .getScopeConstraints(categoryId)
      .pipe(
        map(constraints => new CompleteLoadScopeConstraintsAction({ categoryId, constraints })),
        catchError(_ => of(new FailLoadScopeConstraintsAction(categoryId)))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/role-scope.effects.ts